import { ElementRef, Inject, Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import {
  MatDialogConfig,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';

@Component({
  selector: 'app-popover-confirmation',
  templateUrl: './popover-confirmation.component.html',
  styleUrls: ['./popover-confirmation.component.scss'],
})
export class PopoverConfirmationComponent implements OnInit {
  @Input() id: string | number;
  @Input() status: string;
  @Input() message: string;
  @Input() cancelReasonTreatment: string;

  constructor(
    public dialogRef: MatDialogRef<PopoverConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA)
    public options: {
      id: string | number;
      status: string;
      message: string;
    },
  ) {
    this.id = options.id;
    this.status = options.status;
    this.message = options.message;
  }

  ngOnInit(): void {}

  close(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
